<template>
    <div class="footer-bottom-section mt-5">
    <div class="footer-menu">
        <ul>
          <li>
            <!-- <div class="footer-logo">
              <img src="../assets/Images/landing/footer-logo.jpg" />
            </div> -->
            <p class="mb-0">© {{ new Date().getFullYear() }} Temasek Polytechnic</p>
          </li>
          <li>
            <a :href="terms_url" target="_blank">Terms &amp; Conditions</a>
          </li>
          <li><a :href="privacy_url" target="_blank">Privacy Policy</a></li>
          <li><a href="mailto:wysd-apac-2022@tp.edu.sg?subject=World Youth Skills Day (APAC) 2022">Contact Us</a></li>
          <!-- <li><a href="mailto:vivek.somani@webspiders.com">Contact Us</a></li> -->
        </ul>
    </div>

      <div class="social-links-footer">
        <p>Connect with TP :</p>
        <ul>
          <li>
            <a href="https://www.facebook.com/temasekpoly" target="_blank"
              ><img src="../assets/Images/landing/facebook.png"
            /></a>
          </li>

          <li>
            <a href=" https://www.instagram.com/temasekpoly" target="_blank"
              ><img src="../assets/Images/landing/instagram.png"
            /></a>
          </li>

          <li>
            <a
              href="https://www.linkedin.com/school/temasek-polytechnic"
              target="_blank"
              ><img src="../assets/Images/landing/linkedin.png"
            /></a>
          </li>

          <li>
            <a href="https://www.tiktok.com/@temasekpoly" target="_blank"
              ><img
                src="../assets/Images/landing/logos_tiktok-icon.svg"
                style="height: 25px; width: 25px"
            /></a>
          </li>

          <li>
            <a href="https://twitter.com/temasekpoly" target="_blank"
              ><img src="../assets/Images/landing/twitter.png"
            /></a>
          </li>

          <li>
            <a href="https://t.me/temasekpolyofficial" target="_blank"
              ><img
                src="../assets/Images/landing/telegram-plane.svg"
                style="height: 25px; width: 25px"
            /></a>
          </li>

          <li>
            <a href="https://www.youtube.com/user/temasekpolysg" target="_blank"
              ><img src="../assets/Images/landing/youtube.png"
            /></a>
          </li>
        </ul>
      </div>
    </div>
</template>
<script>
import APIs from "@/components/APIInit";

var self;
export default {
  data() {
    return {
      publicEventCollection: "",
      terms_url: "",
      privacy_url: "",
    };
  },
  created() {
    self = this;
    self.publicEventCollection = self.getPublicEventCollection();
    self.terms_url =
      APIs.googleSoragePath +
      self.publicEventCollection +
      "/Resources/terms_n_conditions.html?alt=media";
    self.privacy_url =
      APIs.googleSoragePath +
      self.publicEventCollection +
      "/Resources/privacy_policy.html?alt=media";
  },
}
</script>